const PRIMARY = {
  main: "#eee",
  contrastText: "#111",
};
const SECONDARY = {
  main: "#e1a853",
  contrastText: "#000",
};

const paletteDark = {
  mode: "dark",
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  // background: { default: "#27374D", paper: "#19222a", disabled: "#526D82" },
  background: { default: "#292b2d", paper: "#3d4042", disabled: "#526D82" },
};

export default paletteDark;
